import { CustomFile } from 'components/features/file-uploader/types';
import React, { useCallback } from 'react';
import { formatFileSize, getFileIcon } from 'utils/format';
import { storageApi } from 'services/apis';
import { CreateUploadedFilePayloadDtoEntityTypeEnum } from 'libs/pinnacle-sdk';
import { useTranslation } from 'react-i18next';

interface FileSummaryProps {
  file: CustomFile;
  sessionId: string;
  entityType: CreateUploadedFilePayloadDtoEntityTypeEnum;
}

const FileSummary: React.FC<FileSummaryProps> = ({
  file,
  sessionId,
  entityType,
}) => {
  const { t } = useTranslation();
  const getBlobName = useCallback(
    (fileName: string) => `${entityType}/${sessionId}/${fileName}`,
    [entityType, sessionId]
  );

  const handleDownload = useCallback(
    async (file: CustomFile) => {
      // prioritize legacy file path for download if exists
      const blobName = file.legacyFilePath ?? getBlobName(file.name);
      const { downloadLink } = await storageApi.getDownloadLink({
        blobName,
        isLegacyFile: !!file.legacyFilePath,
      });
      window.open(downloadLink, '_blank');
    },
    [getBlobName]
  );

  return (
    <div
      className="px-3 py-4 w-full border border-[#E4E4E4] rounded-lg hover:bg-[#E4E4E4] transition-colors cursor-pointer"
      title={file.name}
      onClick={() => handleDownload(file)}
    >
      <div className="flex items-center gap-4">
        <img className="w-10" src={getFileIcon(file.name)} alt={file.name} />
        <div className="flex-1">
          <div className="text-black font-medium text-sm truncate max-w-44">
            {file.name}
          </div>
          <div className="text-[#5E6B7C] text-sm">
            {' '}
            ({formatFileSize(file.size)}) • {t('general.download')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileSummary;
